export default [{
  path: '/testing',
  name: 'testing',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/testing/index')
}]
